import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { BorderedFlex, ComponentRenderer } from '@goodrx/x-core';
import { BlockConfig } from '../../../BlockConfig';
const StyledFlex = styled(BorderedFlex)`
  box-shadow: 0px 15px 18px -15px rgba(5, 15, 35, 0.15);
  border-radius: 8px;

  *:last-child {
    margin-bottom: 0px;
  }
`;
export const Card = ({
  className,
  componentMap,
  contentCollection,
  mobileConfig,
  tabletConfig
}) => {
  const theme = useContext(ThemeContext);
  const items = (contentCollection === null || contentCollection === void 0 ? void 0 : contentCollection.items.filter(item => !!item)) || []; // We want to apply certain values to the inner container, not the standard BlockConfig

  const removeConfig = {
    paddingTop: null,
    paddingBottom: null,
    paddingLeft: null,
    paddingRight: null,
    backgroundColor: null,
    align: null
  };
  const mobileConfigWithDefault = { ...(mobileConfig || {}),
    marginBottom: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginBottom) || '0',
    align: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.align) || 'left',
    ...removeConfig
  };
  const tabletConfigWithDefault = { ...(tabletConfig || {}),
    marginBottom: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginBottom) || '0',
    align: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.align) || 'left',
    ...removeConfig
  };
  const alignmentMap = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  };
  return /*#__PURE__*/React.createElement(BlockConfig, {
    mobileConfig: mobileConfigWithDefault,
    tabletConfig: tabletConfigWithDefault,
    className: className
  }, /*#__PURE__*/React.createElement(StyledFlex, {
    alignItems: {
      _: alignmentMap[(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.align) || 'left'],
      md: alignmentMap[(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.align) || 'left']
    },
    textAlign: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.align) || 'left',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.align) || 'left'
    },
    flexDirection: "column",
    width: "100%",
    mb: "18px",
    pt: {
      _: theme.xSpace[(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.paddingTop) || 4],
      md: theme.xSpace[(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.paddingTop) || 4]
    },
    pb: {
      _: theme.xSpace[(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.paddingTop) || 4],
      md: theme.xSpace[(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.paddingTop) || 4]
    },
    pl: {
      _: theme.xSpace[(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.paddingTop) || 4],
      md: theme.xSpace[(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.paddingTop) || 4]
    },
    pr: {
      _: theme.xSpace[(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.paddingTop) || 4],
      md: theme.xSpace[(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.paddingTop) || 4]
    },
    border: {
      _: mobileConfig !== null && mobileConfig !== void 0 && mobileConfig.backgroundColor ? 'auto' : '1px solid rgba(0, 0, 0, 0.1)',
      md: tabletConfig !== null && tabletConfig !== void 0 && tabletConfig.backgroundColor ? 'auto' : '1px solid rgba(0, 0, 0, 0.1)'
    },
    bg: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.backgroundColor) || '#ffffff',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.backgroundColor) || '#ffffff'
    }
  }, items.map(data => /*#__PURE__*/React.createElement(ComponentRenderer, {
    data: data,
    key: data.sys.id,
    componentMap: componentMap
  }))));
};